import { languages } from "./constants";
import { useIntl } from "react-intl";
import { IOption, LocaleKeyEnum } from 'types';

const useLanguageOptions = (): IOption<LocaleKeyEnum>[] => {
  const intl = useIntl();

  return languages.map(language => ({
    ...language,
    label: intl.formatMessage(({ id: language.label }))
  }));
};

export default useLanguageOptions;
